import createIcon from '../../createIcon';

/**
 * @component @name Polymer
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxNUw3LjExIDE2LjYzTDQuNSAxMkw5IDRINUwwLjUgMTJMNSAyMEg5TDE2Ljg5IDcuMzdMMTkuNSAxMkwxNSAyMEgxOUwyMy41IDEyTDE5IDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Polymer = createIcon('Polymer', [
  [
    'path',
    {
      d: 'M19 4H15L7.11 16.63L4.5 12L9 4H5L0.5 12L5 20H9L16.89 7.37L19.5 12L15 20H19L23.5 12L19 4Z',
      key: 'mjpria',
    },
  ],
]);

export default Polymer;
